import { render, staticRenderFns } from "./IndividualBets.vue?vue&type=template&id=5925e287&scoped=true&"
import script from "./IndividualBets.vue?vue&type=script&lang=js&"
export * from "./IndividualBets.vue?vue&type=script&lang=js&"
import style0 from "./IndividualBets.vue?vue&type=style&index=0&id=5925e287&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5925e287",
  null
  
)

export default component.exports